import * as Immutable from 'immutable';
import { ModuleTypes } from '../../_config/ModuleInfo';
import { IModuleStore } from '../../_stores/ModuleStore';

export interface IModulePatternDesignServiceStore extends IModuleStore {
	id: string,
	loading: boolean,
	source: string,
	categoryId: string,
	colors: Immutable.List<string>,
	color_replacements: Immutable.List<string>,
	thumbnail: string
}

const defaultStore = Immutable.Record<IModulePatternDesignServiceStore>({
	name: undefined,
	type: ModuleTypes.PatternDesignService,
	id: "",
	loading: false,
	source: "",
	categoryId: "",
	colors: Immutable.List<string>(),
	color_replacements: Immutable.List<string>(),
	thumbnail: undefined
});

export default class ModulePatternDesignServiceStore extends defaultStore implements IModulePatternDesignServiceStore {}